import create from "zustand";
import { mountStoreDevtool } from 'simple-zustand-devtools';

const objLoginInicial = {
    email: null,
    nombre: null,
    nivel: null,
    apellido: null,
    token: null
}

const objLogueado = JSON.parse(localStorage.getItem('user')) || objLoginInicial

export const useLoginStore = create( set => ({

    objLogueado,
    setObjLogueado: obj => set( state => ({
        objLogueado: obj
    })),

}))

if (process.env.NODE_ENV === 'development') {
    mountStoreDevtool('store del proyecto', useLoginStore);
}
